import { Injectable } from "@angular/core";

export interface ETagEntry<T> {
  etag: string;
  data: T;
  storedAt: number;
}

@Injectable({ providedIn: "root" })
export class ETagStore {
  private readonly store = new Map<string, ETagEntry<unknown>>();

  buildKey(endpoint: string, params?: Record<string, unknown>): string {
    if (!params || Object.keys(params).length === 0) {
      return endpoint;
    }

    const normalized = Object.keys(params)
      .sort()
      .reduce<Record<string, unknown>>((acc, key) => {
        acc[key] = params[key];
        return acc;
      }, {});

    return `${endpoint}?${JSON.stringify(normalized)}`;
  }

  getEntry<T>(key: string): ETagEntry<T> | null {
    return (this.store.get(key) as ETagEntry<T>) ?? null;
  }

  setEntry<T>(key: string, etag: string, data: T): void {
    this.store.set(key, { etag, data, storedAt: Date.now() });
  }

  clear(key: string): void {
    this.store.delete(key);
  }

  clearByPrefix(prefix: string): void {
    Array.from(this.store.keys()).forEach((key) => {
      if (key.startsWith(prefix)) {
        this.store.delete(key);
      }
    });
  }

}
